import React from 'react'
import { Route } from 'react-router-dom'
import { Motion, spring, presets } from 'react-motion'

import styles from './styles'

const routeMap = {
	'/about': 1,
	'/media': 2,
	'/contact': 3
}

class FadingRoute extends React.Component {
	state = {
		path: '/about',
		translateX: null
	}

	componentWillReceiveProps({ path }) {
		if (this.state.prevRoute !== path) {
			const prevVal = routeMap[this.state.path]
			const currVal = routeMap[path]

			this.setState({
				path,
				translateX: currVal > prevVal ? 100 : -100
			})
		}
	}

	render() {
		const { component: Component, path, ...rest } = this.props

		return (
			<Route
				{...rest}
				render={matchProps => {
					// save route in state
					return (
						<div style={styles.routeContainer}>
							<Motion
								key={path}
								defaultStyle={{ translateX: this.state.translateX, opacity: 0 }}
								style={{
									translateX: spring(0, presets.stiff),
									opacity: spring(1, presets.stiff)
								}}
							>
								{({ translateX, opacity }) => (
									<Component
										style={{
											...styles.component,
											transform: `translateX(${translateX}vw)`,
											opacity
										}}
										{...matchProps}
									/>
								)}
							</Motion>
						</div>
					)
				}}
			/>
		)
	}
}

export default FadingRoute



// WEBPACK FOOTER //
// ./src/views/Root/FadingRoute.js